import { defineComponent as _defineComponent } from 'vue'
import NavigationDrawer from "@/components/app/NavigationDrawer.vue";
import GoTopButton from "@/components/app/GoTopButton.vue";
import { envs } from "@/const/dotenv";
import { Language } from "@/views/cms/content/common/choices";
import ToolbarAdminLanguage from "@/components/toolbar/admin/ToolbarAdminLanguage.vue";
import { axiosInstance } from "@/plugins/axios";
import { Token } from "@/store/modules/auth";
import { tzDayjs } from "@/utils/tzDayjs/index";
import {
  computed,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import store from "@/store";
import router from "@/router";
import ToolbarDataLanguage from "@/components/toolbar/language/ToolbarDataLanguage.vue";
import { useIntervalFn } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const drawer = ref(true);
const time = ref(tzDayjs().toDatetimeString());

const { pause } = useIntervalFn(() => {
  time.value = tzDayjs().toDatetimeString();
}, 1000);
const signedIn = computed((): boolean => {
  if (envs.SKIP_AUTH) {
    return true;
  }

  return (
    store.getters.accessToken &&
    store.getters.expirationTime > Math.floor(Date.now() / 1000)
  );
});

const staffId = computed((): string => store.getters.staffId);

function signOut(): void {
  store.commit("clearToken");
  store.commit("clearKakaopageUserToken");
  window.location.replace(envs.COGNITO_LOGOUT_ENDPOINT);
}

function openSignInPage(): void {
  window.location.replace(envs.COGNITO_LOGIN_ENDPOINT);
}

async function authenticate(authorizationCode: string): Promise<void> {
  const response = await axiosInstance.post<Token>("/auth/token", {
    code: authorizationCode,
  });

  if (response.status === 200) {
    store.commit("setToken", response.data);
    store.commit("clearKakaopageUserToken");

    await router.replace({
      path: "/",
    });
  }
}

function hackUrl(): void {
  /**
   * cognito OAuth2 를 통해 로그인 시 운영툴로 redirect 하는데 cognito 에선 fragment url(#) 을 redirect url 로 지정 불가능하다.
   * https://admin.com/?code=1d29-ffac-c703e#/ 형태로 불완전하게 redirect 되는데 이를 바로 잡고,
   * 인증에 필요한 authorization code 도 올바르게 쿼리로 넘긴다.
   */
  if (location.href.indexOf("/#/") === -1) {
    // const params = new URL(location.href).searchParams;
    // const code = params.get("code");
    const split = location.href.split("/?code=");
    if (split.length > 1) {
      const code = split[1].replace("#/", "");
      if (code) {
        location.href = `/#/?authCode=${code}`;
      }
    }
  }
}

onBeforeUnmount(() => pause());
watch(
  () => router.app.$route.query,
  async () => {
    const authorizationCode = router.app.$route.query["authCode"];
    if (typeof authorizationCode === "string") {
      await authenticate(authorizationCode);
    }
  },
  { immediate: true, deep: true },
);
onBeforeMount(() => {
  // TODO: 추후 서비스 언어 선택 구현되면 vuex-persistedstate를 통해서 구현
  store.commit(
    "setLanguage",
    (envs.SERVICE_LANG_CODE_LIST || [Language.KOREAN])[0],
  );
  store.commit(
    "setServiceLanguage",
    (envs.SERVICE_LANG_CODE_LIST || [Language.KOREAN])[0],
  );
});
onMounted(() => hackUrl());

return { __sfc: true,drawer, time, pause, signedIn, staffId, signOut, openSignInPage, authenticate, hackUrl, NavigationDrawer, GoTopButton, ToolbarAdminLanguage, ToolbarDataLanguage }
}

})